import React, { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAccessToken } from "utills/appStorage";

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  const accessToken = getAccessToken();
  const location = useLocation();

  if (!accessToken) {
    /**
     * Carry the page they asked for through to login.
     *
     * This previously redirected with no record of where the user was going,
     * so a staff member following a link to a specific record signed in and
     * landed on the dashboard, with no way back except to find it again.
     *
     * `state` rather than a query parameter: it never appears in the URL bar,
     * so it cannot be crafted by someone sending a link, which removes the
     * open-redirect risk entirely. `replace` keeps the protected URL out of
     * history, so the back button does not bounce off the guard.
     */
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;
